/* eslint-disable import/prefer-default-export */
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// REPLACE: replace with project-specific Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyD_4sEP1RxZmiGJaB-Yy2J3qoQmuLh7gHk",
  appId: "1:1080046077031:web:2ab3c57e120e20da5ec0c2",
  authDomain: "side-project-stack-6ec08.firebaseapp.com",
  measurementId: "G-QJ2SY4CY69",
  messagingSenderId: "1080046077031",
  projectId: "side-project-stack-6ec08",
  storageBucket: "side-project-stack-6ec08.appspot.com",
};

// See this link for available libraries
// https://firebase.google.com/docs/web/setup#available-libraries

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const firebaseAuth = getAuth(app);

// Initialize Analytics
export const firebaseAnalytics = getAnalytics(app);

// Initialize Firebase Storage
export const firebaseStorage = getStorage(app);
